/**
 * Checks if the current page view is from a Google Performance Max ad campaign
 * @param searchParams - Next.js searchParams object from the page
 * @returns true if utm_campaign contains EJ_GG_PMAX_
 */
export const isFromGooglePmax = (searchParams?: { [key: string]: string | string[] | undefined }): boolean => {
  if (!searchParams || !searchParams.utm_campaign) {
    return false;
  }

  // Normalize array parameter to string
  const campaign = Array.isArray(searchParams.utm_campaign) 
    ? searchParams.utm_campaign[0] 
    : searchParams.utm_campaign;

  // Check if campaign contains EJ_GG_PMAX_
  return campaign ? campaign.toUpperCase().includes('EJ_GG_PMAX_') : false;
};
